export const PriceTierType = Object.freeze({
    DistributionVolume: 'DISTRIBUTION_VOLUME',
    MerchantPallets: 'MERCHANT_PALLETS',
    MerchantParcels: 'MERCHANT_PARCELS',
    BoxDistribution: 'BOX_DISTRIBUTION',
})
